var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgNoSignal = function SvgNoSignal(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 414 311"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-signal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M0 0h414v310.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M335.585 234.392H414v76.11h-78.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44433e",
    d: "M312.328 310.502v-76.11h43.111v23.545c0 .481-.169.946-.478 1.312l-3.264 3.873a2.72 2.72 0 0 0 .31 3.812l4.213 3.592a4.07 4.07 0 0 1 1.276 4.172l-1.767 6.459a8.2 8.2 0 0 0-.29 2.159v27.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M279.101 310.5v-76.108l50.445.002v23.101c0 .734-.392 1.41-1.025 1.766l-6.085 3.431c-2.026 1.142-1.738 4.183.465 4.915l9.432 3.13c2.762.916 3.66 4.425 1.685 6.586l-3.41 3.732a4.07 4.07 0 0 0-1.062 2.746v26.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44433e",
    d: "M253.185 310.502v-76.11h42.729v22.761c0 .905-.593 1.699-1.452 1.945l-9.136 2.612c-2.674.765-2.544 4.651.175 5.23l15.061 3.208c3.327.709 4.309 5.041 1.621 7.15l-4.722 3.705a4.06 4.06 0 0 0-1.547 3.196v26.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M131.578 310.502v-76.11h145.873v21.653c0 .951-.655 1.774-1.573 1.975l-11.817 2.587c-2.883.632-2.758 4.841.156 5.297l21.819 3.407c3.953.618 4.648 6.092.977 7.703l-7.159 3.141a4.04 4.04 0 0 0-2.403 3.709v26.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9baac7",
    d: "M344.889 0H414v200.041h-69.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab3a29",
    d: "M257.171 200.041V0h97.872v125.955a6.1 6.1 0 0 1-.731 2.904l-2.318 4.306a7.49 7.49 0 0 0 .864 8.369l4.042 4.783c2.565 3.037 2.292 7.588-.619 10.286l-2.534 2.35a4.07 4.07 0 0 0-.257 5.687 6.1 6.1 0 0 1 1.553 4.07v12.799c0 1.565-.597 3.07-1.667 4.199l-2.042 2.155a.68.68 0 0 0 .074 1l4.385 3.42c.444.347.626.939.455 1.48l-1.392 3.853v2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df9199",
    d: "M190.718 200.041V0h96.796v118.357c0 2.399-1.395 4.571-3.559 5.543l-11.344 5.092c-4.02 1.805-3.554 7.733.697 8.87l32.15 8.598c2.377.636 2.702 3.92.497 5.022l-21.743 10.866c-1.102.551-1.455 1.972-.741 2.986l3.177 4.511c.563.8.866 1.757.866 2.739v7.96c0 2.032-1.285 3.836-3.189 4.475l-6.761 2.272c-.66.221-.583 1.192.103 1.304l18.264 2.98c1.339.218 1.533 2.09.268 2.586l-8.685 3.404v2.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0bc7c",
    d: "M140.214 200.041V0h85.316v114.667c0 2.511-1.528 4.762-3.842 5.66l-23.224 9.016c-4.535 1.761-3.71 8.501 1.112 9.085l65.908 7.974c2.903.352 3.201 4.503.379 5.276l-43.449 11.91c-1.582.434-2 2.51-.713 3.538l3.792 3.028a4.74 4.74 0 0 1 1.773 3.703v6.42c0 2.272-1.598 4.22-3.801 4.636l-14.29 2.694c-.746.141-.713 1.237.041 1.331l31.201 3.893c1.545.193 1.56 2.458.017 2.672l-14.904 2.062v2.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b085c1",
    d: "M98.35 200.041V0h77.039v115.061c0 2.311-1.296 4.421-3.342 5.44l-22.106 11.015c-4.214 2.099-3.055 8.484 1.62 8.925l73.348 6.932c3.039.287 3.282 4.691.294 5.32l-52.829 11.124c-1.607.338-2.145 2.391-.914 3.492l2.357 2.11a4.74 4.74 0 0 1 1.572 3.534v6.777c0 2.183-1.478 4.08-3.573 4.586l-12.986 3.138c-.732.177-.656 1.256.093 1.326l31.998 2.98c1.528.143 1.641 2.361.136 2.663l-15.668 3.142v2.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf00",
    d: "M111.262 121.861V0h-58.1v200.041h58.1v-.719a2.69 2.69 0 0 1 1.903-2.583l7.213-2.166c.658-.197.625-1.151-.043-1.303l-17.398-3.941c-.63-.143-.709-1.021-.116-1.277l3.594-1.553c2.94-1.27 4.847-4.196 4.847-7.435v-5.077a8.16 8.16 0 0 0-1.38-4.545l-1.416-2.11c-1.35-2.012-.214-4.766 2.146-5.206l32.51-6.062c1.35-.252 1.483-2.161.181-2.603l-40.353-13.684c-3.923-1.33-4.91-6.49-1.763-9.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbdb3",
    d: "M57.2 125.72V0H0v200.041h57.2v-1.264c0-1.101.38-2.167 1.074-3.014l.13-.159a1.69 1.69 0 0 0-.178-2.325l-1.726-1.542a2.14 2.14 0 0 1-.005-3.179c.448-.403.705-.981.705-1.588v-17.686c0-1.405-.29-2.794-.849-4.079l-.136-.312c-.873-2.006-.267-4.358 1.463-5.674l4.657-3.543c1.518-1.155 1.775-3.362.563-4.843l-6.188-7.567a10.21 10.21 0 0 1-1.633-10.064l1.462-3.865c.437-1.154.66-2.38.66-3.617"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9baac7",
    d: "M0 200.043h59.143v34.35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M59.144 200.043h59.143v34.35H59.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df9199",
    d: "M118.285 200.043h59.143v34.35h-59.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M177.428 200.043h59.143v34.35h-59.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M236.572 200.043h59.143v34.35h-59.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b085c1",
    d: "M295.716 200.043h59.143v34.35h-59.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbdb3",
    d: "M354.856 200.043h59.143v34.35h-59.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b085c1",
    d: "M113.634 310.502v-76.11h77.548v21.511a2.01 2.01 0 0 1-1.733 2.004l-29.383 3.915c-3.189.425-3.031 5.155.179 5.36l55.355 3.538c3.973.254 4.225 6.085.289 6.69l-21.318 3.278c-1.948.3-3.389 1.998-3.389 3.996v25.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M62.466 310.502v-76.11h77.414v21.795c0 .885-.568 1.667-1.403 1.93l-17.273 5.433c-2.066.65-1.775 3.702.376 3.939l43.379 4.766c2.274.25 2.41 3.552.165 3.993l-22.016 4.327c-1.874.369-3.228 2.032-3.228 3.967v25.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#597e6f",
    d: "M69.499 257.635v-23.243H0v76.11h69.499v-28.368c0-1.493.698-2.898 1.88-3.787l1.49-1.12c1.96-1.472 1.738-4.511-.413-5.675l-7.145-3.869c-1.194-.647-1.419-2.286-.443-3.238l3.001-2.928a5.42 5.42 0 0 0 1.63-3.882"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-signal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h414v310.5H0z"
  }))))));
};
export default SvgNoSignal;